import styled from 'styled-components';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: white;
  transform: translateX(${props => props.show ? '0' : '-100%'});
  transition: transform 0.3s ease-in-out;
  z-index: 1000;
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding: 2rem;
  gap: 1rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 0;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  font-family: "Pixelify Sans", sans-serif;
  top: 35px;
  right: 3em;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 24px;
  padding: 0;
`;

const VideoSection = styled.div`
  width: 100%;
  height: 100%;
`;

const Video = styled.video`
  width: 100%;
  height: 92%;
  object-fit: cover;
`;

const InfoSection = styled.div`
  padding: 1rem;
  position: relative;

  @media (max-width: 768px) {
    top: -1em;
  }
`;

const ProductTitle = styled.h2`
  font-family: "Pixelify Sans", sans-serif;
  margin-bottom: 1rem;
`;

const Select = styled.select`
  font-family: "Pixelify Sans", sans-serif;
  padding: 0.5rem;
  margin: 1rem 0;
  border: 2px solid black;
`;

const Button = styled.button`
  font-family: "Pixelify Sans", sans-serif;
  background: black;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  margin: 0.5rem 0;
  margin-left: 1em;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
  &:disabled {
    cursor: not-allowed;
    opacity: 0.4;
  }
`;

const Description = styled.div`
  margin-top: 2rem;
  font-family: "Pixelify Sans", sans-serif;
  text-align: left;
  color: black;
  font-size: 18px;
  margin-right: 2em;
  max-height: 40vh; /* Set a maximum height of 40% of viewport height */
  overflow-y: auto; /* Enable vertical scrolling */

  @media (max-width: 768px) {
    margin-right: 0;
  }

  /* Optional: Customize scrollbar appearance */
  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }
`;

const LearnMore = ({ show, onClose, itemInfo, onAddToCart }) => {
  debugger
  if (!itemInfo) return null;

  return (
    <Overlay show={show}>
      <VideoSection>
        <Video key={itemInfo.vid} autoPlay loop muted>
          <source src={itemInfo.vid} type="video/mp4" />
        </Video>
      </VideoSection>

      <InfoSection>
        <ProductTitle>{itemInfo.name}</ProductTitle>
        <div>{itemInfo.price}</div>

        <Select id={`${itemInfo.id}-type`} defaultValue={itemInfo.types[0]}>
        <option value="" disabled>Select Size</option>
        {itemInfo.types.map((type, i) => (
            <option key={i} value={type}>{type}</option>
        ))}
        </Select>

        <Button disabled onClick={() => onAddToCart(itemInfo.id)}>
        Sold Out
        </Button>
        

        <Description>
          {itemInfo.description.map((text, i) => (
            <p key={i}>{text}</p>
          ))}
        </Description>
        <CloseButton onClick={onClose}>X</CloseButton>
      </InfoSection>
    </Overlay>
  );
};

export default LearnMore;